
  import Cookies from "js-cookie";
  import {getLanguage} from "@/lang";

  export default {
    data() {
      return {
        words: [],
        videos: [],
        packages: [],
        language:Cookies.get('language') || getLanguage(),
        loading_show:false,
        type:this.$route.query.type
      }
    },
    mounted() {
      this.loading_show=true
      this.$ajax.post("/etv/selectHelpInfo.json").then(res => {
        if (res.data.code === 0) {
          this.loading_show=false
          this.words = res.data.data.word.filter(item => item.hpEnable !== 0)
          this.videos = res.data.data.video.filter(item => item.hpEnable !== 0)
          this.packages = res.data.data.package.filter(item => item.hpEnable !== 0)
        }
      })

    },
    methods: {
      handleResize() {
        // 获取底部导航栏元素
        const tabbar = document.querySelector('.van-tabbar')
        tabbar.style.display = 'none'
      },
      back() {
        this.$router.push('/my')
      },
      goto(url) {
        window.open(url, '_blank')
      },
      gotoAddress(url){
        return url.replace('/web', '')
      },
      truncatedName(fullName) {
          // 截断名称并确保括号内容完整显示
          const namePart = fullName.split(' (')[0];
          const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : '';

          // 判断是否为英文名（假设英文名不包含中文字符）
          const isEnglish = /^[A-Za-z\s]+$/.test(namePart);

          // 根据是否为英文名选择不同的截断长度
          const maxLength = isEnglish ? 24 : 14;

          if (namePart.length <= maxLength) {
            return fullName;
          } else {
            return `${namePart.substring(0, maxLength)}...${infoPart}`;
          }
      },
    }
  }
